// extracted by mini-css-extract-plugin
module.exports = {"root":"index-module--root--21teB","content":"index-module--content--cUA2r","contentIn":"index-module--contentIn--2z5Pu","img":"index-module--img--2jQyX"};